import { render } from "./FavoriteSidebarTab.vue?vue&type=template&id=ed53895c&scoped=true"
import script from "./FavoriteSidebarTab.vue?vue&type=script&lang=js"
export * from "./FavoriteSidebarTab.vue?vue&type=script&lang=js"

import "./FavoriteSidebarTab.vue?vue&type=style&index=0&id=ed53895c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed53895c"]])

export default __exports__